import { FunctionComponent } from "react";
import { StyledForm } from "./form.styles";

interface FormProps {
  className?: string;
  children: any;
}

const Form: FunctionComponent<FormProps> = ({ className, children }) => {
  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  return (
    <StyledForm className={className} onSubmit={handleSubmit}>
      {children}
    </StyledForm>
  );
};

export default Form;
